import React from "react";
import "./tooltip.css";

const Tooltip = ({ children, text }) => (
  <span className="tooltip-wrapper">
    {children}
    <span className="tooltip-box">{text}</span>
  </span>
);

export default Tooltip;
